(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-accordion-single]').forEach(function (accordion) {
        if (accordion.dataset.accordionSingleBound === '1') return;
        accordion.dataset.accordionSingleBound = '1';
        accordion.addEventListener('toggle', function (e) {
          if (!(e.target instanceof HTMLDetailsElement) || !e.target.open) return;
          accordion.querySelectorAll('details[open]').forEach(function (detail) {
            if (detail !== e.target) detail.open = false;
          });
        }, true);
      });
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["back-in-stock"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      var handler = root.querySelector('[data-back-in-stock-handler]');
      if (!handler) return;
      if (handler.dataset.backInStockBound === '1') return;
      handler.dataset.backInStockBound = '1';

      var isLoggedIn = handler.hasAttribute('data-customer-logged-in');
      var customerEmail = handler.getAttribute('data-customer-email') || '';
      var loginUrl = handler.getAttribute('data-account-login-url') || '/account/login';
      var alreadyRequestedLabel = handler.dataset.alreadyRequestedLabel || 'Already requested for this item';
      var serviceUnavailableLabel = handler.dataset.serviceUnavailableLabel || 'Notification service unavailable. Try again later.';
      var successLabel = handler.dataset.successLabel || "You'll be notified when it's back in stock.";
      var failedLabel = handler.dataset.failedLabel || "Couldn't save your request. Try again.";
      var STORAGE_KEY = 'bis_requested';

      function getRequested() {
        try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || []; }
        catch (e) { return []; }
      }
      function markRequested(variantId) {
        var list = getRequested();
        if (list.indexOf(variantId) === -1) {
          list.push(variantId);
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        }
      }
      function isAlreadyRequested(variantId) {
        return getRequested().indexOf(variantId) !== -1;
      }
      function showToast(message, icon) {
        if (window.showToast) {
          window.showToast('back-in-stock-toast', { message: message, icon: icon, duration: 4000 });
        }
      }

      function submitToSwym(btn) {
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        var productId = parseInt(btn.getAttribute('data-product-id'), 10);
        var productUrl = btn.getAttribute('data-product-url') || '';
        var price = parseFloat(btn.getAttribute('data-variant-price')) || 0;
        if (isAlreadyRequested(String(variantId))) {
          showToast(alreadyRequestedLabel, 'info');
          return;
        }
        if (typeof window._swat === 'undefined') {
          showToast(serviceUnavailableLabel, 'x');
          return;
        }
        window._swat.sendWatchlist(
          customerEmail,
          'email',
          {
            epi: variantId,
            empi: productId,
            du: window.location.origin + productUrl,
            pr: price / 100,
            et: 8
          },
          function () {
            markRequested(String(variantId));
            showToast(successLabel, 'check');
          },
          function () {
            showToast(failedLabel, 'x');
          }
        );
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-back-in-stock]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        if (isLoggedIn) submitToSwym(btn);
        else {
          var dialogApi = window['dialog_back_in_stock_signin'];
          if (dialogApi) dialogApi.open();
        }
      });

      var dialogEl = document.getElementById('back-in-stock-signin');
      if (dialogEl) {
        dialogEl.addEventListener('dialog:confirm', function () {
          window.location.href = loginUrl;
        });
      }
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      var notification = root.querySelector('#cart-notification');
      if (!notification) return;
      if (notification.dataset.cartNotificationBound === '1') return;
      notification.dataset.cartNotificationBound = '1';

      // Move into the sticky header group so the notification participates
      // in overscroll / rubber-banding with the nav.
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) headerGroup.appendChild(notification);

      var panel = notification.querySelector('[data-cart-notification-panel]');
      var closeBtn = notification.querySelector('[data-cart-notification-close]');
      var messageEl = notification.querySelector('[data-cart-notification-message]');
      var labelOne = notification.dataset.cartLabelOne || '__COUNT__';
      var labelOther = notification.dataset.cartLabelOther || '__COUNT__';
      var addingLabel = notification.dataset.addingLabel || 'Adding';
      var itemsAddedOne = notification.dataset.itemsAddedOne || '__COUNT__ product added to cart';
      var itemsAddedOther = notification.dataset.itemsAddedOther || '__COUNT__ products added to cart';
      var addFailedLabel = notification.dataset.addFailedLabel || "Couldn't add item.";
      var stockLimitLabel = notification.dataset.stockLimitLabel || 'All available stock is in your cart.';

      var hideTimer = null;
      var isOpen = false;

      function show(qty) {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        var tmpl = qty === 1 ? itemsAddedOne : itemsAddedOther;
        messageEl.textContent = tmpl.replace('__COUNT__', String(qty));
        if (!isOpen) {
          notification.classList.add('cart-notification-visible');
          isOpen = true;
        }
        hideTimer = setTimeout(hide, 4000);
      }

      function hide() {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        notification.classList.remove('cart-notification-visible');
        isOpen = false;
      }

      function buildCartLabel(count) {
        var template = count === 1 ? labelOne : labelOther;
        return template.replace('__COUNT__', String(count));
      }

      // Render the badge from a cart payload supplied by the shared store.
      function renderBadge(cart) {
        if (!cart || !cart.items) return;
        var giftVids = window.giftVariantIds || [];
        var count = 0;
        cart.items.forEach(function (item) {
          if (giftVids.indexOf(item.variant_id) === -1) count += item.quantity;
        });
        var countEls = document.querySelectorAll('[data-cart-count]');
        var cartIcon = document.querySelector('[data-cart-icon]');
        var liveRegion = document.querySelector('[data-cart-live]');

        if (countEls.length > 0) {
          countEls.forEach(function (el) {
            el.textContent = count > 99 ? '99+' : count;
          });
        } else if (cartIcon && count > 0) {
          var span = document.createElement('span');
          span.className = 'text-xs font-semibold tabular-nums';
          span.setAttribute('data-cart-count', '');
          span.textContent = count > 99 ? '99+' : count;
          cartIcon.appendChild(span);
        }
        if (cartIcon) cartIcon.setAttribute('aria-label', buildCartLabel(count));
        if (liveRegion) liveRegion.textContent = buildCartLabel(count);
      }

      // Subscribe to the shared cart store. The store coalesces duplicate
      // /cart.js fetches across the page, so main-cart / main-product /
      // product-table all see the same payload without firing extra requests.
      var ns = window.pigment;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      function refreshCartCount() {
        if (ns && ns.cart) return ns.cart.refresh().then(renderBadge);
        return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(renderBadge);
      }
      if (ns && ns.cart) {
        ns.cart.subscribe(renderBadge);
      }

      closeBtn.addEventListener('click', hide);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) hide();
      });
      notification.addEventListener('click', function (e) {
        if (!panel.contains(e.target)) hide();
      });

      // Intercept add-to-cart submissions. Skip if a previous handler already
      // dealt with the event (defence against double-binding from a stale page).
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (e.defaultPrevented) return;
        var isProductForm = form.id === 'product-form';
        var isCartAddForm = form.action && form.action.indexOf('/cart/add') !== -1;
        if (!isProductForm && !isCartAddForm) return;

        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"], button[data-add-to-cart]');
        var btnText = submitBtn ? submitBtn.querySelector('[data-btn-text]') : null;
        var btnSpinner = submitBtn ? submitBtn.querySelector('[role="status"]') : null;
        var originalLabel = btnText ? btnText.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          if (btnText) btnText.textContent = addingLabel;
          if (btnSpinner) btnSpinner.style.display = '';
        }

        var formData = new FormData(form);
        var qty = parseInt(formData.get('quantity'), 10) || 1;
        var item = {
          id: parseInt(formData.get('id'), 10),
          quantity: qty
        };
        var properties = {};
        for (var pair of formData.entries()) {
          var m = pair[0].match(/^properties\[(.+)\]$/);
          if (m) properties[m[1]] = pair[1];
        }
        if (Object.keys(properties).length) item.properties = properties;
        var sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = parseInt(sellingPlan, 10);

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || addFailedLabel);
              });
            }
            return response.json();
          })
          .then(function () {
            show(qty);
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (submitBtn) {
              submitBtn.disabled = false;
              if (btnSpinner) btnSpinner.style.display = 'none';
              if (btnText) btnText.textContent = originalLabel;
            }
          })
          .catch(function (err) {
            var errMsg = (err.message || '').toLowerCase();
            var isStockError = errMsg.indexOf('cart') !== -1 || errMsg.indexOf('stock') !== -1 || errMsg.indexOf('inventory') !== -1;
            if (window.showToast) {
              window.showToast('cart-error-toast', {
                message: isStockError ? stockLimitLabel : err.message,
                icon: isStockError ? 'info' : 'x',
                duration: 4000
              });
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              if (btnSpinner) btnSpinner.style.display = 'none';
              if (btnText) btnText.textContent = originalLabel;
            }
          });
      });

      function onCartAdd(data) {
        var items = data.items || [data];
        var totalQty = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        show(totalQty);
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }

      window.cartNotification = {
        show: show,
        hide: hide,
        onCartAdd: onCartAdd,
        refreshCartCount: refreshCartCount
      };

      // Initial badge sync — uses the shared store so we don't double-fetch
      // alongside other components on the page.
      refreshCartCount();
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-countdown"] && !Shopify.designMode) return;
  try {
    (function() {
    function initCountdown(container) {
      if (container.dataset.deliveryCountdownBound === '1') return;
      container.dataset.deliveryCountdownBound = '1';

      var cutoffs;
      try {
        cutoffs = JSON.parse(container.dataset.cutoffs);
      } catch (e) {
        /* A merchant can type anything into the cutoff fields. A broken
           payload should leave the page alone rather than throw. */
        return;
      }
      if (!cutoffs) return;

      // Pause the per-second update while the tab is hidden so we don't waste
      // wakeups on backgrounded pages (mirrors the main-hero pattern).
      var timer = null;
      function start() {
        if (timer) return;
        update();
        timer = setInterval(function () {
          /* The theme editor can replace this section while the timer runs.
             Stop rather than tick against a detached node. */
          if (!container.isConnected) { stop(); return; }
          update();
        }, 30000);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      if (window.pigment && window.pigment.onVisibility) {
        window.pigment.onVisibility(function (hidden) {
          if (hidden) stop(); else start();
        });
      } else {
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop(); else start();
        });
      }

      var activeEl = container.querySelector('[data-countdown-active]');
      var deliveryDayEl = container.querySelector('[data-countdown-delivery-day]');
      var hoursEl = container.querySelector('[data-countdown-hours]');
      var minutesEl = container.querySelector('[data-countdown-minutes]');

      var dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

      function getUKTime() {
        return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
      }

      function isShippingDay(dayName) {
        if (dayName === 'saturday') return cutoffs.saturday && cutoffs.saturday.enabled;
        if (dayName === 'sunday') return cutoffs.sunday && cutoffs.sunday.enabled;
        return true;
      }

      function parseTime(timeStr) {
        var parts = String(timeStr).split(':').map(Number);
        if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) return null;
        return { hours: parts[0], minutes: parts[1] };
      }

      function pad(num) {
        return String(num).padStart(2, '0');
      }

      function getNextCutoff() {
        var now = getUKTime();

        for (var i = 0; i <= 7; i++) {
          var checkDate = new Date(now);
          checkDate.setDate(checkDate.getDate() + i);
          var dayName = dayNames[checkDate.getDay()];

          if (!isShippingDay(dayName)) continue;

          var config = cutoffs[dayName];
          if (!config || !config.time) continue;

          var cutoff = parseTime(config.time);
          if (!cutoff) continue;
          var cutoffDate = new Date(checkDate);
          cutoffDate.setHours(cutoff.hours, cutoff.minutes, 0, 0);

          if (now < cutoffDate) {
            return {
              cutoffDate: cutoffDate,
              diff: cutoffDate - now,
              deliveryDay: config.ships,
              isToday: i === 0
            };
          }
        }

        return null;
      }

      function getDeliveryLabel(deliveryDay) {
        var now = getUKTime();
        var tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        var tomorrowName = dayNames[tomorrow.getDay()];

        if (!deliveryDay) return '';
        if (String(deliveryDay).toLowerCase() === tomorrowName) {
          return 'Tomorrow';
        }
        return deliveryDay.charAt(0).toUpperCase() + deliveryDay.slice(1);
      }

      function update() {
        var info = getNextCutoff();

        if (!info) {
          activeEl.classList.add('hidden');
          return;
        }

        var totalSeconds = Math.floor(info.diff / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.ceil((totalSeconds % 3600) / 60);
        if (minutes === 60) { hours += 1; minutes = 0; }

        deliveryDayEl.textContent = getDeliveryLabel(info.deliveryDay);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);

        activeEl.classList.remove('hidden');
      }

      start();
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-delivery-countdown]').forEach(initCountdown);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(dialog) {
      if (dialog.dataset.dialogBound === '1') return;
      dialog.dataset.dialogBound = '1';
      var id = dialog.id;
      var backdrop = dialog.querySelector('[data-dialog-backdrop]');
      var panel = dialog.querySelector('[data-dialog-panel]');
      var cancelBtn = dialog.querySelector('[data-dialog-cancel]');
      var confirmBtn = dialog.querySelector('[data-dialog-confirm]');
      var triggerEl = null;

      function open() {
        dialog.classList.add('dialog-visible');
        dialog.style.visibility = 'visible';
        dialog.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          if (backdrop) {
            backdrop.classList.remove('opacity-0');
            backdrop.classList.add('opacity-100');
          }
          if (panel) {
            panel.classList.remove('opacity-0', 'scale-95');
            panel.classList.add('opacity-100', 'scale-100');
          }
        });
        setTimeout(function () {
          if (!panel) return;
          var first = panel.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (first) first.focus();
        }, 200);
      }

      function close() {
        if (backdrop) {
          backdrop.classList.remove('opacity-100');
          backdrop.classList.add('opacity-0');
        }
        if (panel) {
          panel.classList.remove('opacity-100', 'scale-100');
          panel.classList.add('opacity-0', 'scale-95');
        }
        setTimeout(function () {
          dialog.classList.remove('dialog-visible');
          dialog.style.visibility = 'hidden';
          dialog.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
          if (triggerEl) triggerEl.focus();
          dialog.dispatchEvent(new CustomEvent('dialog:close'));
        }, 300);
      }

      document.querySelectorAll('[data-dialog-open="' + id + '"]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          triggerEl = trigger;
          open();
        });
      });

      if (cancelBtn) cancelBtn.addEventListener('click', function () {
        dialog.dispatchEvent(new CustomEvent('dialog:cancel'));
        close();
      });
      if (confirmBtn) confirmBtn.addEventListener('click', function () {
        dialog.dispatchEvent(new CustomEvent('dialog:confirm'));
        close();
      });
      if (backdrop) backdrop.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && dialog.getAttribute('aria-hidden') === 'false') close();
      });

      if (panel) panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      window['dialog_' + id.replace(/-/g, '_')] = { open: open, close: close };
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-dialog]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(drawer) {
      if (drawer.dataset.drawerBound === '1') return;
      drawer.dataset.drawerBound = '1';
      var id = drawer.id;
      var backdrop = drawer.querySelector('[data-drawer-backdrop]');
      var panel = drawer.querySelector('[data-drawer-panel]');
      var closeBtn = drawer.querySelector('[data-drawer-close]');
      var position = drawer.dataset.drawerPosition || 'right';

      function open() {
        drawer.classList.add('drawer-visible');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          if (backdrop) {
            backdrop.classList.remove('opacity-0');
            backdrop.classList.add('opacity-100');
          }
          if (panel) {
            panel.classList.remove(position === 'left' ? '-translate-x-full' : 'translate-x-full');
            panel.classList.add('translate-x-0');
          }
        });
      }

      function close() {
        if (backdrop) {
          backdrop.classList.remove('opacity-100');
          backdrop.classList.add('opacity-0');
        }
        if (panel) {
          panel.classList.remove('translate-x-0');
          panel.classList.add(position === 'left' ? '-translate-x-full' : 'translate-x-full');
        }
        setTimeout(function () {
          drawer.classList.remove('drawer-visible');
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }, 300);
      }

      var triggerId = drawer.dataset.drawerTriggerId;
      if (triggerId) {
        var trigger = document.getElementById(triggerId);
        if (trigger) trigger.addEventListener('click', open);
      }
      document.querySelectorAll('[data-drawer-trigger="' + id + '"]').forEach(function (el) {
        el.addEventListener('click', open);
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (backdrop) backdrop.addEventListener('click', close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });

      window['drawer_' + id.replace(/-/g, '_')] = { open: open, close: close };
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-drawer]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["modal"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('dialog[data-modal]').forEach(function (modal) {
        if (modal.dataset.modalBound === '1') return;
        modal.dataset.modalBound = '1';
        var id = modal.id;
        var openerSelector = '[data-modal-open="' + id + '"]';

        document.querySelectorAll(openerSelector).forEach(function (trigger) {
          trigger.addEventListener('click', function () { modal.showModal(); });
        });

        modal.querySelectorAll('[data-modal-close]').forEach(function (btn) {
          btn.addEventListener('click', function () { modal.close(); });
        });

        modal.addEventListener('click', function (e) {
          if (e.target === modal) modal.close();
        });

        modal.addEventListener('close', function () {
          var active = document.activeElement;
          var focusInModal = !active || active === document.body || modal.contains(active);
          if (!focusInModal) return;
          var opener = document.querySelector(openerSelector);
          if (opener) opener.focus();
        });
      });
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(wrapper) {
      if (wrapper.dataset.newsletterBound === '1') return;
      wrapper.dataset.newsletterBound = '1';

      var formId = wrapper.dataset.formId;
      var form = formId ? document.getElementById(formId) : wrapper.querySelector('form');
      if (!form) return;

      var loadingLabel = wrapper.dataset.loadingLabel || 'Sending…';
      var successLabel = wrapper.dataset.successLabel || 'Subscribed';
      var errorLabel = wrapper.dataset.errorLabel || "Couldn't subscribe. Check your email and try again.";

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button[type="submit"]');
        var originalLabel = submitBtn ? submitBtn.textContent : '';

        form.setAttribute('aria-busy', 'true');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = loadingLabel;
        }

        var formData = new FormData(form);
        fetch(form.action, { method: 'POST', body: formData })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var responseForm = formId ? doc.getElementById(formId) : null;
            var errorEl = responseForm && responseForm.querySelector('[role="alert"]');
            if (errorEl) {
              window.showToast && window.showToast('newsletter-toast', {
                message: errorEl.textContent.trim() || errorLabel,
                icon: 'x',
                duration: 4000
              });
            } else {
              if (emailInput) emailInput.value = '';
              window.showToast && window.showToast('newsletter-toast', {
                message: successLabel,
                icon: 'check',
                duration: 3000
              });
            }
          })
          .catch(function () {
            window.showToast && window.showToast('newsletter-toast', {
              message: errorLabel,
              icon: 'x',
              duration: 4000
            });
          })
          .then(function () {
            form.setAttribute('aria-busy', 'false');
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalLabel;
            }
          });
      });
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-newsletter-form]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-pagination]').forEach(function (pagination) {
        if (pagination.dataset.paginationBound === '1') return;
        pagination.dataset.paginationBound = '1';
        var currentPage = pagination.querySelector('[data-pagination-current]');
        var pageLinks = pagination.querySelectorAll('[data-pagination-link]');
        if (!currentPage || !pageLinks.length) return;
        pageLinks.forEach(function (link) {
          link.addEventListener('mouseenter', function () {
            currentPage.classList.remove('bg-secondary');
            currentPage.classList.add('bg-background');
            link.classList.remove('bg-background');
            link.classList.add('bg-secondary');
          });
          link.addEventListener('mouseleave', function () {
            link.classList.remove('bg-secondary');
            link.classList.add('bg-background');
            currentPage.classList.remove('bg-background');
            currentPage.classList.add('bg-secondary');
          });
        });
      });
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pcCardInit) return;
    window.__pcCardInit = true;

    /* ── Network conditions: skip all prefetch / hover-warming on
       Save-Data or constrained connections so metered users don't pay
       for speculative downloads. ── */
    var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
    var saveData = !!(conn && (conn.saveData || /(2g|slow-2g)/.test(conn.effectiveType || '')));

    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    /* ── Secondary-image hover swap (existing behaviour) ── */
    function activateSecondary(img) {
      if (img.dataset.pcSecondaryActivated) return;
      img.dataset.pcSecondaryActivated = '1';
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      if (img.dataset.src) img.src = img.dataset.src;
    }

    /* ── PDP main-image prefetch on intent ──
       The product page's main image uses
         widths: '480,640,768,900,1024,1200,1500'
         sizes:  '(min-width: 1024px) 50vw, 100vw'
       so we predict which width the destination browser will pick by
       running the same calculation here (vw + DPR), then warm the HTTP
       cache with that one URL via <link rel=prefetch as=image>. When
       the user actually clicks through, the LCP image is already in
       cache and the PDP renders almost instantly.

       We trigger on pointerenter (desktop hover) and touchstart
       (mobile tap-down, ~100–200ms before the click fires) so by the
       time the navigation lands, the byte transfer is already done. */
    var PDP_WIDTHS = [480, 640, 768, 900, 1024, 1200, 1500];
    function pickPdpWidth() {
      var dpr = window.devicePixelRatio || 1;
      var vw = window.innerWidth || document.documentElement.clientWidth || 1024;
      var cssW = vw >= 1024 ? vw * 0.5 : vw;
      var needed = Math.ceil(cssW * dpr);
      for (var i = 0; i < PDP_WIDTHS.length; i++) {
        if (PDP_WIDTHS[i] >= needed) return PDP_WIDTHS[i];
      }
      return PDP_WIDTHS[PDP_WIDTHS.length - 1];
    }

    /* Module-level dedupe set so multiple cards pointing at the same
       product (e.g. duplicates across "Best Selling" + "Recommendations")
       only fire one prefetch. Lives outside prefetchPdpImage so the
       lookup is O(1) instead of a DOM query. */
    var prefetchedUrls = new Set();

    function prefetchPdpImage(card) {
      if (saveData) return;
      if (card.dataset.pcPdpPrefetched) return;
      var base = card.dataset.pdpImageBase;
      if (!base) return;
      card.dataset.pcPdpPrefetched = '1';
      try {
        var u = new URL(base, window.location.href);
        u.searchParams.set('width', String(pickPdpWidth()));
        var href = u.toString();
        if (prefetchedUrls.has(href)) return;
        prefetchedUrls.add(href);

        /* Why `new Image()` and not `<link rel="prefetch" as="image">`:
           ----------------------------------------------------------
           <link rel=prefetch> issues a generic resource request with
           `Accept: * / *`. Shopify's image CDN content-negotiates WebP
           and AVIF off the `Accept` header AND sets `Vary: Accept` on
           the response, so a prefetch request returns the original
           PNG/JPG and is stored in the HTTP cache under a different
           cache key than the WebP variant the destination PDP will
           request (the PDP's <img> sends
           `Accept: image/avif,image/webp,...`). End result: the
           prefetched bytes are wasted and the PDP downloads the image
           a second time on cold cache.

           The DOM Image constructor issues a real image-typed request
           with the same Accept headers a normal <img> would use, so
           the CDN returns WebP/AVIF and the response lands in the
           same cache key the PDP will hit. fetchPriority='low' keeps
           the speculative load from competing with the current
           page's visible image work. */
        var img = new Image();
        if ('fetchPriority' in img) img.fetchPriority = 'low';
        img.decoding = 'async';
        img.src = href;
      } catch (e) { /* swallow URL parse errors */ }
    }

    /* ── Document-level event delegation ──
       The previous implementation snapshotted
       `querySelectorAll('[data-product-card]')` once at script load and
       attached per-card listeners. That broke any card injected after
       initial render — most importantly the automated recommendations
       carousel on PDPs, which replaces its container's innerHTML after
       a deferred /recommendations fetch. Those new cards never received
       hover/touch/focus listeners and so never warmed the PDP image
       cache.

       Delegating from `document` means a card anywhere in the app —
       collection grids, search results, recommendation carousels, the
       brand "More from" carousel, anything inserted by future AJAX
       work — gets the exact same hover-prefetch behaviour for free,
       with no per-section JS and no need to re-initialise after DOM
       mutations. We use a dataset flag (`pcCardBound`) to dedupe so
       each card only fires intent handling once. */
    function handleIntent(e) {
      var card = e.target.closest && e.target.closest('[data-product-card]');
      if (!card) return;
      if (card.dataset.pcCardBound) return;
      card.dataset.pcCardBound = '1';
      var secondaryImg = card.querySelector('img[data-product-card-secondary]');
      if (secondaryImg && canHover) activateSecondary(secondaryImg);
      prefetchPdpImage(card);
    }

    /* pointerover (not pointerenter) bubbles, so document-level
       delegation works. focusin bubbles by design. touchstart fires on
       finger-down ~100–200ms before the click, giving touch users the
       same head start as desktop hover. All passive — we never call
       preventDefault and we want the browser's scroll/INP fast path. */
    document.addEventListener('pointerover', handleIntent, { passive: true });
    document.addEventListener('focusin', handleIntent, { passive: true });
    document.addEventListener('touchstart', handleIntent, { passive: true });

    /* ── Variant-count overflow fetch ──
       product.variants.size is capped at 250 in Liquid, so cards for
       products with >250 variants render with "View 250 …". The real
       total comes from sections/variant-count.liquid via the Section
       Rendering API; we fetch lazily (IntersectionObserver) and only
       for cards that hit the cap, dedupe per handle across the page
       (collection grids may show the same handle twice via repeated
       sections), and cache results in sessionStorage so paginated
       collection pages don't re-fetch the same handle on every page. */
    var VC_CACHE_KEY = 'variantCounts:v1';
    var vcCache = {};
    try {
      vcCache = JSON.parse(sessionStorage.getItem(VC_CACHE_KEY) || '{}') || {};
    } catch (e) { vcCache = {}; }
    var vcInflight = {};

    function vcPersist() {
      try { sessionStorage.setItem(VC_CACHE_KEY, JSON.stringify(vcCache)); } catch (e) {}
    }

    function vcApply(host, total) {
      var current = host.dataset.variantCountCurrent || '250';
      if (String(total) === current) return;
      var btn = host.querySelector('a, button');
      if (!btn) return;
      /* Walk text nodes and replace the first occurrence of the capped
         number — the button label is plain text from the translation
         "View {count} {label}", so a single targeted swap is safe and
         leaves the surrounding label untouched. */
      var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf(current) !== -1) {
          node.nodeValue = node.nodeValue.replace(current, String(total));
          host.dataset.variantCountCurrent = String(total);
          return;
        }
      }
    }

    function vcFetch(host) {
      var handle = host.dataset.variantCountHandle;
      if (!handle) return;
      if (vcCache[handle] != null) { vcApply(host, vcCache[handle]); return; }
      if (vcInflight[handle]) {
        vcInflight[handle].push(host);
        return;
      }
      vcInflight[handle] = [host];
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'products/' + encodeURIComponent(handle) + '?section_id=variant-count', {
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var n = parseInt((html || '').replace(/<[^>]*>/g, '').trim(), 10);
          if (!isFinite(n) || n <= 0) return;
          vcCache[handle] = n;
          vcPersist();
          (vcInflight[handle] || []).forEach(function (h) { vcApply(h, n); });
        })
        .catch(function () { /* leave the 250 fallback in place */ })
        .then(function () { delete vcInflight[handle]; });
    }

    var vcObserver = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            vcObserver.unobserve(entry.target);
            vcFetch(entry.target);
          });
        }, { rootMargin: '200px' })
      : null;

    function vcBind(host) {
      if (host.dataset.vcBound) return;
      host.dataset.vcBound = '1';
      if (vcObserver) vcObserver.observe(host);
      else vcFetch(host);
    }

    function vcScan(root) {
      (root || document).querySelectorAll('[data-variant-count-fetch]').forEach(vcBind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { vcScan(document); });
    } else {
      vcScan(document);
    }

    /* Recommendation carousels and other AJAX surfaces inject cards
       after initial render; pick those up too. */
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-variant-count-fetch]')) vcBind(n);
          if (n.querySelectorAll) vcScan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-popover"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(controls) {
      if (controls.dataset.qtyBound === '1') return;
      // Parent contexts that install their own click handler (product-table,
      // main-cart line items, variant-swatch-row) opt out via this attribute
      // — without this guard the popover's +1 and the parent's +step would
      // both fire on every click, advancing the value by 2× step.
      if (controls.hasAttribute('data-quantity-no-bind')) return;
      controls.dataset.qtyBound = '1';
      var input = controls.querySelector('[data-quantity-input]');
      var minusBtn = controls.querySelector('[data-quantity-minus]');
      var plusBtn = controls.querySelector('[data-quantity-plus]');
      if (!input || !minusBtn || !plusBtn) return;

      var min = parseInt(input.min, 10) || 0;
      var step = parseInt(input.step, 10) || 1;
      var isUpdating = false;

      function getMax() {
        return input.max !== '' && input.max !== undefined ? parseInt(input.max, 10) : -1;
      }
      function updateButtons() {
        var value = parseInt(input.value, 10) || 0;
        var max = getMax();
        minusBtn.disabled = value <= min;
        plusBtn.disabled = max >= 0 && value >= max;
      }
      function updateValue(newValue) {
        var max = getMax();
        var clamped = Math.max(min, newValue);
        if (max >= 0) clamped = Math.min(max, clamped);
        input.value = clamped;
        updateButtons();
        isUpdating = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        isUpdating = false;
      }

      minusBtn.addEventListener('click', function () {
        updateValue((parseInt(input.value, 10) || 0) - step);
      });
      plusBtn.addEventListener('click', function () {
        updateValue((parseInt(input.value, 10) || 0) + step);
      });
      input.addEventListener('change', function () {
        if (isUpdating) return;
        var val = parseInt(input.value, 10);
        if (isNaN(val) || val < min) updateValue(min);
        else updateValue(val);
      });
      input.addEventListener('blur', function () {
        if (input.value === '' || isNaN(parseInt(input.value, 10))) {
          input.value = min;
          updateButtons();
        }
      });

      updateButtons();
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-quantity-controls]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
    // Re-scan after dynamic insertions (e.g. cart drawer / main-cart re-renders).
    document.addEventListener('quantity-popover:rescan', function () {
      document.querySelectorAll('[data-quantity-controls]').forEach(bind);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(container) {
      if (container.dataset.sliderBound === '1') return;
      container.dataset.sliderBound = '1';

      var trackInner = container.querySelector('[data-slider-track-inner]');
      var activeTrack = container.querySelector('[data-slider-active-track]');
      var minHandle = container.querySelector('[data-slider-handle="min"]');
      var maxHandle = container.querySelector('[data-slider-handle="max"]');
      var minDisplay = container.querySelector('[data-slider-min-display]');
      var maxDisplay = container.querySelector('[data-slider-max-display]');
      var minInput = container.querySelector('[data-slider-input-min]');
      var maxInput = container.querySelector('[data-slider-input-max]');
      if (!trackInner || !minHandle || !maxHandle) return;

      var min = parseFloat(container.dataset.min);
      var max = parseFloat(container.dataset.max);
      var step = parseFloat(container.dataset.step);
      var autoSubmit = container.dataset.autoSubmit === 'true';

      var currentMin = parseFloat(container.dataset.currentMin);
      var currentMax = parseFloat(container.dataset.currentMax);
      var activeHandle = null;

      function valueToPercent(value) {
        return ((value - min) / (max - min)) * 100;
      }
      function percentToValue(percent) {
        var rawValue = (percent / 100) * (max - min) + min;
        var steppedValue = Math.round(rawValue / step) * step;
        return Math.max(min, Math.min(max, steppedValue));
      }
      function updateUI() {
        var minPercent = valueToPercent(currentMin);
        var maxPercent = valueToPercent(currentMax);
        minHandle.style.left = minPercent + '%';
        maxHandle.style.left = maxPercent + '%';
        activeTrack.style.left = minPercent + '%';
        activeTrack.style.right = (100 - maxPercent) + '%';
        if (minDisplay) minDisplay.textContent = Math.round(currentMin);
        if (maxDisplay) maxDisplay.textContent = Math.round(currentMax);
        minHandle.setAttribute('aria-valuenow', currentMin);
        maxHandle.setAttribute('aria-valuenow', currentMax);
        if (minInput) minInput.value = Math.round(currentMin);
        if (maxInput) maxInput.value = Math.round(currentMax);
      }

      function getPercentFromEvent(e) {
        var rect = trackInner.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var percent = ((clientX - rect.left) / rect.width) * 100;
        return Math.max(0, Math.min(100, percent));
      }

      function onMove(e) {
        if (!activeHandle) return;
        e.preventDefault();
        var percent = getPercentFromEvent(e);
        var value = percentToValue(percent);
        if (activeHandle === minHandle) {
          currentMin = Math.min(value, currentMax - step);
        } else {
          currentMax = Math.max(value, currentMin + step);
        }
        updateUI();
      }

      function onEnd() {
        if (!activeHandle) return;
        activeHandle.classList.remove('active:scale-110');
        activeHandle = null;
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
        if (autoSubmit) {
          var form = container.closest('form');
          if (form) form.submit();
        }
      }

      function onStart(e, handle) {
        e.preventDefault();
        activeHandle = handle;
        handle.classList.add('active:scale-110');
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      }

      minHandle.addEventListener('mousedown', function (e) { onStart(e, minHandle); });
      maxHandle.addEventListener('mousedown', function (e) { onStart(e, maxHandle); });
      minHandle.addEventListener('touchstart', function (e) { onStart(e, minHandle); }, { passive: false });
      maxHandle.addEventListener('touchstart', function (e) { onStart(e, maxHandle); }, { passive: false });

      function handleKeydown(e, handle) {
        var isMin = handle === minHandle;
        var value = isMin ? currentMin : currentMax;
        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            value -= step;
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            value += step;
            break;
          default:
            return;
        }
        e.preventDefault();
        if (isMin) {
          currentMin = Math.max(min, Math.min(value, currentMax - step));
        } else {
          currentMax = Math.min(max, Math.max(value, currentMin + step));
        }
        updateUI();
      }

      minHandle.addEventListener('keydown', function (e) { handleKeydown(e, minHandle); });
      maxHandle.addEventListener('keydown', function (e) { handleKeydown(e, maxHandle); });

      trackInner.addEventListener('click', function (e) {
        if (e.target.classList.contains('slider-handle')) return;
        var percent = getPercentFromEvent(e);
        var value = percentToValue(percent);
        var minDist = Math.abs(value - currentMin);
        var maxDist = Math.abs(value - currentMax);
        if (minDist <= maxDist) {
          currentMin = Math.min(value, currentMax - step);
        } else {
          currentMax = Math.max(value, currentMin + step);
        }
        updateUI();
        if (autoSubmit) {
          var form = container.closest('form');
          if (form) form.submit();
        }
      });

      updateUI();
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-slider]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-tabs]').forEach(function (tablist) {
        if (tablist.dataset.tabsBound === '1') return;
        tablist.dataset.tabsBound = '1';

        var buttons = tablist.querySelectorAll('[data-tab-button]');

        buttons.forEach(function (btn) {
          var panelId = btn.dataset.tabButton;
          document.querySelectorAll('[data-tab-panel="' + panelId + '"]').forEach(function (panel) {
            if (!panel.hasAttribute('role')) panel.setAttribute('role', 'tabpanel');
            if (!panel.getAttribute('aria-labelledby')) panel.setAttribute('aria-labelledby', btn.id);
          });
        });

        function activateTab(tabId) {
          buttons.forEach(function (btn) {
            var isActive = btn.dataset.tabButton === tabId;
            btn.setAttribute('aria-selected', isActive);
            btn.tabIndex = isActive ? 0 : -1;
            if (isActive) {
              btn.classList.add('bg-background', 'text-foreground', 'shadow-sm');
              btn.classList.remove('text-muted-foreground', 'hover:text-foreground');
            } else {
              btn.classList.remove('bg-background', 'text-foreground', 'shadow-sm');
              btn.classList.add('text-muted-foreground', 'hover:text-foreground');
            }
          });
          document.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
            var match = panel.dataset.tabPanel === tabId;
            panel.hidden = !match;
            panel.setAttribute('aria-hidden', match ? 'false' : 'true');
          });
          tablist.dispatchEvent(new CustomEvent('tab-change', {
            detail: { tabId: tabId },
            bubbles: true
          }));
        }

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            activateTab(btn.dataset.tabButton);
          });
          btn.addEventListener('keydown', function (e) {
            var index = Array.prototype.indexOf.call(buttons, btn);
            var newIndex;
            switch (e.key) {
              case 'ArrowLeft':
                newIndex = index > 0 ? index - 1 : buttons.length - 1;
                break;
              case 'ArrowRight':
                newIndex = index < buttons.length - 1 ? index + 1 : 0;
                break;
              case 'Home':
                newIndex = 0;
                break;
              case 'End':
                newIndex = buttons.length - 1;
                break;
              default:
                return;
            }
            e.preventDefault();
            buttons[newIndex].focus();
            activateTab(buttons[newIndex].dataset.tabButton);
          });
        });
      });
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toast"] && !Shopify.designMode) return;
  try {
    (function () {
    var SVGS = {
      'check': '<svg class="w-5 h-5 shrink-0 text-success" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
      'x': '<svg class="w-5 h-5 shrink-0 text-destructive" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
      'info': '<svg class="w-5 h-5 shrink-0 text-foreground" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" /></svg>',
      'warning': '<svg class="w-5 h-5 shrink-0 text-destructive" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" /></svg>'
    };

    function bind(toast) {
      if (toast.dataset.toastBound === '1') return;
      toast.dataset.toastBound = '1';
      var stack = toast.querySelector('[data-toast-stack]');
      if (!stack) return;
      var toasts = [];

      function repositionStack() {
        var count = toasts.length;
        toasts.forEach(function (t, i) {
          var depth = count - 1 - i;
          var el = t.el;
          var offset = Math.min(depth, 3) * 12;
          var scale = Math.max(1 - depth * 0.05, 0.85);
          el.style.transform = depth === 0
            ? 'translateX(-50%) translateY(0) scale(1)'
            : 'translateX(-50%) translateY(' + offset + 'px) scale(' + scale + ')';
          el.style.opacity = depth >= 3 ? '0' : '1';
          el.style.zIndex = count - depth;
        });
      }

      function removeToast(entry) {
        if (toasts.indexOf(entry) === -1) return;
        entry.el.style.transform = 'translateX(-50%) translateY(-100%) scale(1)';
        entry.el.style.opacity = '0';
        setTimeout(function () {
          entry.el.remove();
          var idx = toasts.indexOf(entry);
          if (idx !== -1) toasts.splice(idx, 1);
          repositionStack();
        }, 300);
      }

      function show(options) {
        options = options || {};
        var message = options.message || '';
        var icon = options.icon || '';
        var duration = options.duration || 3000;

        var panel = document.createElement('div');
        panel.className = 'flex items-center gap-3 bg-background px-5 py-3 shadow-xl pointer-events-auto border border-border absolute left-1/2';
        panel.style.cssText = 'top: 0; width: min(380px, calc(100vw - 2rem)); transform: translateX(-50%) translateY(-100%); opacity: 0; transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease; transform-origin: top center;';

        if (icon && SVGS[icon]) {
          var iconSpan = document.createElement('span');
          iconSpan.innerHTML = SVGS[icon];
          panel.appendChild(iconSpan);
        }

        var msg = document.createElement('p');
        msg.className = 'text-sm font-medium text-foreground min-w-0 break-words overflow-hidden';
        msg.textContent = message;
        panel.appendChild(msg);

        stack.appendChild(panel);

        var entry = { el: panel, timer: null };
        toasts.push(entry);

        requestAnimationFrame(function () {
          requestAnimationFrame(repositionStack);
        });

        entry.timer = setTimeout(function () { removeToast(entry); }, duration);
      }

      function hide() {
        var latest = toasts[toasts.length - 1];
        if (latest) {
          if (latest.timer) clearTimeout(latest.timer);
          removeToast(latest);
        }
      }

      window['toast_' + toast.id.replace(/-/g, '_')] = { show: show, hide: hide };
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-toast]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }

    window.showToast = window.showToast || function (id, options) {
      var api = window['toast_' + id.replace(/-/g, '_')];
      if (api) api.show(options);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function bind(selector) {
      if (selector.dataset.variantSelectorBound === '1') return;
      selector.dataset.variantSelectorBound = '1';

      var dataEl = selector.querySelector('[data-variant-selector-data]');
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var buttons = selector.querySelectorAll('[data-option-button]');
      var variantInput = selector.querySelector('[data-variant-id]');

      function getCurrentOptions() {
        var options = {};
        buttons.forEach(function (btn) {
          if (btn.getAttribute('aria-pressed') === 'true') {
            options[btn.dataset.optionName] = btn.dataset.optionValue;
          }
        });
        return options;
      }
      function findVariant(options) {
        return product.variants.find(function (variant) {
          return product.options.every(function (optionName, index) {
            return variant.options[index] === options[optionName];
          });
        });
      }

      // INP fix: collapse the multiple classList.add/remove calls into one
      // string-based className swap per button so each click triggers a
      // single style invalidation per element instead of N.
      var TEXT_SELECTED = 'border-primary bg-primary text-primary-foreground';
      var TEXT_UNSELECTED = 'border-input bg-background text-foreground';
      var SWATCH_SELECTED = 'ring-2 ring-primary ring-offset-2';

      function applyButtonState(btn, isSelected) {
        var hasSwatch = !!btn.querySelector('[class*="color-swatch"]');
        var cls = btn.className;
        if (hasSwatch) {
          cls = cls.replace(' ring-2 ring-primary ring-offset-2', '');
          if (isSelected) cls += ' ' + SWATCH_SELECTED;
        } else {
          cls = cls.replace(/ ?border-primary ?bg-primary ?text-primary-foreground/, '')
                   .replace(/ ?border-input ?bg-background ?text-foreground/, '');
          cls += ' ' + (isSelected ? TEXT_SELECTED : TEXT_UNSELECTED);
        }
        btn.className = cls.trim().replace(/\s+/g, ' ');
        btn.setAttribute('aria-pressed', isSelected);
      }

      function updateSelection(clickedButton) {
        var optionName = clickedButton.dataset.optionName;
        buttons.forEach(function (btn) {
          if (btn.dataset.optionName === optionName) {
            applyButtonState(btn, btn === clickedButton);
          }
        });
        var labelSpan = selector.querySelector('[data-selected-option="' + optionName + '"]');
        if (labelSpan) labelSpan.textContent = clickedButton.dataset.optionValue;

        var options = getCurrentOptions();
        var variant = findVariant(options);
        if (variant) {
          variantInput.value = variant.id;
          selector.dispatchEvent(new CustomEvent('variant-change', {
            detail: { variant: variant },
            bubbles: true
          }));
          var url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!btn.disabled) updateSelection(btn);
        });
      });
    }

    function pigmentInitAll(root) {
      root = root || document;
      root.querySelectorAll('[data-variant-selector]').forEach(bind);
    }

    if (window.pigment && window.pigment.onSectionRender) {
      window.pigment.onSectionRender(pigmentInitAll);
    } else {
      pigmentInitAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
